import { Form, Link, useLocation } from '@remix-run/react'
import { useRef } from 'react'

import {
	Button,
	Container,
	Icon,
	NavigationMenu,
	NavigationMenuItem,
	NavigationMenuLink,
	NavigationMenuList,
	navigationMenuTriggerStyle,
} from '#app/components/ui'
import { Logo } from './logo.tsx'
import MobileNavigation from './mobile-nav.tsx'

interface HeaderProps {
	isLoggedIn: boolean
}

export default function Header({ isLoggedIn }: HeaderProps) {
	const location = useLocation()
	const pathname = location.pathname
	const formRef = useRef<HTMLFormElement>(null)
	return (
		<header className="mt-4 bg-white dark:bg-background">
			<Container>
				<nav className="relative z-50 flex justify-between">
					<div className="-ml-4 flex items-center md:gap-x-12">
						{isLoggedIn === true && (
							<Link to="/dashboard" className="-mt-9" aria-label="Dashboard">
								<Logo className="h-20 w-auto" />
							</Link>
						)}
						{isLoggedIn === false && (
							<Link to="/" className="-mt-9" aria-label="Home">
								<Logo className="h-20 w-auto" />
							</Link>
						)}
						{pathname === '/' && (
							<div className="hidden md:flex md:gap-x-6">
								<NavigationMenu>
									<NavigationMenuList>
										<NavigationMenuItem>
											<NavigationMenuLink
												to="#features"
												className={navigationMenuTriggerStyle()}
											>
												Features
											</NavigationMenuLink>
										</NavigationMenuItem>
										<NavigationMenuItem>
											<NavigationMenuLink
												to="#testimonials"
												className={navigationMenuTriggerStyle()}
											>
												Testimonials
											</NavigationMenuLink>
										</NavigationMenuItem>
										{/* <NavigationMenuItem>
												<NavigationMenuLink
												to="#pricing"
													className={navigationMenuTriggerStyle()}
												>
													Pricing
												</NavigationMenuLink>
										</NavigationMenuItem> */}
									</NavigationMenuList>
								</NavigationMenu>
							</div>
						)}
					</div>
					<div className="flex items-center gap-x-5 md:gap-x-8">
						<NavigationMenu>
							<NavigationMenuList>
								<div className="hidden md:block">
									{isLoggedIn === true && (
										<>
											<NavigationMenuItem
												className={navigationMenuTriggerStyle()}
											>
												<Form action="/logout" method="POST" ref={formRef}>
													<button type="submit">
														<Icon className="text-body-sm" name="exit">
															Logout
														</Icon>
													</button>
												</Form>
											</NavigationMenuItem>
										</>
									)}
									{isLoggedIn === false && (
										<NavigationMenuItem>
											<NavigationMenuLink
												to="/login"
												className={navigationMenuTriggerStyle()}
											>
												Log in
											</NavigationMenuLink>
										</NavigationMenuItem>
									)}
								</div>
								{isLoggedIn === true && (
									<NavigationMenuItem>
										<Button>
											<Link to="/dashboard">Dashboard</Link>
										</Button>
									</NavigationMenuItem>
								)}
								{isLoggedIn === false && (
									<NavigationMenuItem>
										<Link to="/signup">
											<Button>
												<span>
													Get started{' '}
													<span className="hidden lg:inline">today</span>
												</span>
											</Button>
										</Link>
									</NavigationMenuItem>
								)}
							</NavigationMenuList>
						</NavigationMenu>

						<div className="-mr-1 md:hidden">
							<MobileNavigation isLoggedIn={isLoggedIn} />
						</div>
					</div>
				</nav>
			</Container>
		</header>
	)
}
